import {Rule} from '../../models/svg-rule/rule.model';
import {IRuleSystem} from '../../models/svg-rule/rule-system.model';
import {Color} from '../../enums/color';
import {TcddTrainTabUtil, ValueIndex} from '../../utils/tcdd-train-tab-util';
import {TcddMainSystem} from '../../enums/tcdd-main-system.enum';
import {TcddSubSystem} from '../../enums/tcdd-sub-system.enum';
import {TcddSubSystemType} from '../../enums/tcdd-sub-system-type.enum';
import {DoorSystemKeys} from '../../constants/tcdd-system-keys/door-system-keys';
import {DOOR_SYSTEM} from '../../constants/tcdd-system-contants/door-system.constant';
import {TCDD_UNIT} from '../../constants/tcdd-unit-constant';
import {createColorRule} from '../../utils/tcdd-rule-util';

function getIndex(key: string): ValueIndex {
  return TcddTrainTabUtil.getValueIndex(
    TcddMainSystem.DIAGNOSTIC_SYSTEM,
    TcddSubSystem.DOOR_SYSTEM,
    TcddSubSystemType.SUB,
    key
  );
}

export class DoorSystemRules implements IRuleSystem {
  public getRules(): Rule[] {
    return [
      createColorRule(TCDD_UNIT.OUTER_DOOR_1, (wagonIndex: number, data: any[], setColor: (color: Color) => void) => {
        const wagonData = data?.[TcddSubSystem.DOOR_SYSTEM]?.[wagonIndex];
        if (!wagonData) return false;

        const isOuterDoor1CommunicationError: ValueIndex = getIndex(DoorSystemKeys.isOuterDoor1CommunicationError); // === 1 will be pink
        const isOuterDoor1OutOfService: ValueIndex = getIndex(DoorSystemKeys.isOuterDoor1OutOfService); // === 1 will be yellow
        const isOuterDoor1MajorError: ValueIndex = getIndex(DoorSystemKeys.isOuterDoor1MajorError); // === 1 will be red
        const isOuterDoor1MinorError: ValueIndex = getIndex(DoorSystemKeys.isOuterDoor1MinorError); // === 1 will be orange
        const isOuterDoor1FullyOpen: ValueIndex = getIndex(DoorSystemKeys.isOuterDoor1FullyOpen); // === 1 will be light green
        const isOuterDoor1Enabled: ValueIndex = getIndex(DoorSystemKeys.isOuterDoor1Enabled); // === 1 will be blue
        const isOuterDoor1ClosedAndLocked: ValueIndex = getIndex(DoorSystemKeys.isOuterDoor1ClosedAndLocked); // === 1 will be gray

        // Pink state
        if (Number(wagonData[isOuterDoor1CommunicationError.groupIndex]?.[isOuterDoor1CommunicationError.infoIndex]) === DOOR_SYSTEM.STATUS.OUTER_DOOR_COMMUNICATION_ERROR) {
          setColor(Color.Pink); return true;
        }
        // Yellow state
        if (Number(wagonData[isOuterDoor1OutOfService.groupIndex]?.[isOuterDoor1OutOfService.infoIndex]) === DOOR_SYSTEM.STATUS.OUTER_DOOR_OUT_OF_SERVICE) {
          setColor(Color.Yellow ); return true;
        }
        // Red State
        if (Number(wagonData[isOuterDoor1MajorError.groupIndex]?.[isOuterDoor1MajorError.infoIndex]) === DOOR_SYSTEM.STATUS.OUTER_DOOR_MAJOR_ERROR) {
          setColor(Color.Red); return true;
        }
        // Orange state
        if (Number(wagonData[isOuterDoor1MinorError.groupIndex]?.[isOuterDoor1MinorError.infoIndex]) === DOOR_SYSTEM.STATUS.OUTER_DOOR_MINOR_ERROR) {
          setColor(Color.Orange); return true;
        }
        // Light green state
        if (Number(wagonData[isOuterDoor1FullyOpen.groupIndex]?.[isOuterDoor1FullyOpen.infoIndex]) === DOOR_SYSTEM.STATUS.OUTER_DOOR_FULLY_OPEN) {
          setColor(Color.Green); return true;
        }
        // Blue state
        if (Number(wagonData[isOuterDoor1Enabled.groupIndex]?.[isOuterDoor1Enabled.infoIndex]) === DOOR_SYSTEM.STATUS.OUTER_DOOR_ENABLED) {
          setColor(Color.Blue); return true;
        }
        // Gray state
        if (Number(wagonData[isOuterDoor1ClosedAndLocked.groupIndex]?.[isOuterDoor1ClosedAndLocked.infoIndex]) === DOOR_SYSTEM.STATUS.OUTER_DOOR_CLOSED_AND_LOCKED) {
          setColor(Color.Gray); return true;
        }

        return false;
      }),
      createColorRule(TCDD_UNIT.OUTER_DOOR_2, (wagonIndex: number, data: any[], setColor: (color: Color) => void) => {
        const wagonData = data?.[TcddSubSystem.DOOR_SYSTEM]?.[wagonIndex];
        if (!wagonData) return false;

        const isOuterDoor2CommunicationError: ValueIndex = getIndex(DoorSystemKeys.isOuterDoor2CommunicationError); // === 1 will be pink
        const isOuterDoor2OutOfService: ValueIndex = getIndex(DoorSystemKeys.isOuterDoor2OutOfService); // === 1 will be yellow
        const isOuterDoor2MajorError: ValueIndex = getIndex(DoorSystemKeys.isOuterDoor2MajorError); // === 1 will be red
        const isOuterDoor2MinorError: ValueIndex = getIndex(DoorSystemKeys.isOuterDoor2MinorError); // === 1 will be orange
        const isOuterDoor2FullyOpen: ValueIndex = getIndex(DoorSystemKeys.isOuterDoor2FullyOpen); // === 1 will be light green
        const isOuterDoor2Enabled: ValueIndex = getIndex(DoorSystemKeys.isOuterDoor2Enabled); // === 1 will be blue
        const isOuterDoor2ClosedAndLocked: ValueIndex = getIndex(DoorSystemKeys.isOuterDoor2ClosedAndLocked); // === 1 will be gray

        // Pink state
        if (Number(wagonData[isOuterDoor2CommunicationError.groupIndex]?.[isOuterDoor2CommunicationError.infoIndex]) === DOOR_SYSTEM.STATUS.OUTER_DOOR_COMMUNICATION_ERROR) {
          setColor(Color.Pink); return true;
        }
        // Yellow state
        if (Number(wagonData[isOuterDoor2OutOfService.groupIndex]?.[isOuterDoor2OutOfService.infoIndex]) === DOOR_SYSTEM.STATUS.OUTER_DOOR_OUT_OF_SERVICE) {
          setColor(Color.Yellow ); return true;
        }
        // Red State
        if (Number(wagonData[isOuterDoor2MajorError.groupIndex]?.[isOuterDoor2MajorError.infoIndex]) === DOOR_SYSTEM.STATUS.OUTER_DOOR_MAJOR_ERROR) {
          setColor(Color.Red); return true;
        }
        // Orange state
        if (Number(wagonData[isOuterDoor2MinorError.groupIndex]?.[isOuterDoor2MinorError.infoIndex]) === DOOR_SYSTEM.STATUS.OUTER_DOOR_MINOR_ERROR) {
          setColor(Color.Orange); return true;
        }
        // Light green state
        if (Number(wagonData[isOuterDoor2FullyOpen.groupIndex]?.[isOuterDoor2FullyOpen.infoIndex]) === DOOR_SYSTEM.STATUS.OUTER_DOOR_FULLY_OPEN) {
          setColor(Color.Green); return true;
        }
        // Blue state
        if (Number(wagonData[isOuterDoor2Enabled.groupIndex]?.[isOuterDoor2Enabled.infoIndex]) === DOOR_SYSTEM.STATUS.OUTER_DOOR_ENABLED) {
          setColor(Color.Blue); return true;
        }
        // Gray state
        if (Number(wagonData[isOuterDoor2ClosedAndLocked.groupIndex]?.[isOuterDoor2ClosedAndLocked.infoIndex]) === DOOR_SYSTEM.STATUS.OUTER_DOOR_CLOSED_AND_LOCKED) {
          setColor(Color.Gray); return true;
        }

        return false;
      }),
      createColorRule(TCDD_UNIT.OUTER_DOOR_3, (wagonIndex: number, data: any[], setColor: (color: Color) => void) => {
        const wagonData = data?.[TcddSubSystem.DOOR_SYSTEM]?.[wagonIndex];
        if (!wagonData) return false;

        const isOuterDoor3CommunicationError: ValueIndex = getIndex(DoorSystemKeys.isOuterDoor3CommunicationError); // === 1 will be pink
        const isOuterDoor3OutOfService: ValueIndex = getIndex(DoorSystemKeys.isOuterDoor3OutOfService); // === 1 will be yellow
        const isOuterDoor3MajorError: ValueIndex = getIndex(DoorSystemKeys.isOuterDoor3MajorError); // === 1 will be red
        const isOuterDoor3MinorError: ValueIndex = getIndex(DoorSystemKeys.isOuterDoor3MinorError); // === 1 will be orange
        const isOuterDoor3FullyOpen: ValueIndex = getIndex(DoorSystemKeys.isOuterDoor3FullyOpen); // === 1 will be light green
        const isOuterDoor3Enabled: ValueIndex = getIndex(DoorSystemKeys.isOuterDoor3Enabled); // === 1 will be blue
        const isOuterDoor3ClosedAndLocked: ValueIndex = getIndex(DoorSystemKeys.isOuterDoor3ClosedAndLocked); // === 1 will be gray

        // Pink state
        if (Number(wagonData[isOuterDoor3CommunicationError.groupIndex]?.[isOuterDoor3CommunicationError.infoIndex]) === DOOR_SYSTEM.STATUS.OUTER_DOOR_COMMUNICATION_ERROR) {
          setColor(Color.Pink); return true;
        }
        // Yellow state
        if (Number(wagonData[isOuterDoor3OutOfService.groupIndex]?.[isOuterDoor3OutOfService.infoIndex]) === DOOR_SYSTEM.STATUS.OUTER_DOOR_OUT_OF_SERVICE) {
          setColor(Color.Yellow ); return true;
        }
        // Red State
        if (Number(wagonData[isOuterDoor3MajorError.groupIndex]?.[isOuterDoor3MajorError.infoIndex]) === DOOR_SYSTEM.STATUS.OUTER_DOOR_MAJOR_ERROR) {
          setColor(Color.Red); return true;
        }
        // Orange state
        if (Number(wagonData[isOuterDoor3MinorError.groupIndex]?.[isOuterDoor3MinorError.infoIndex]) === DOOR_SYSTEM.STATUS.OUTER_DOOR_MINOR_ERROR) {
          setColor(Color.Orange); return true;
        }
        // Light green state
        if (Number(wagonData[isOuterDoor3FullyOpen.groupIndex]?.[isOuterDoor3FullyOpen.infoIndex]) === DOOR_SYSTEM.STATUS.OUTER_DOOR_FULLY_OPEN) {
          setColor(Color.Green); return true;
        }
        // Blue state
        if (Number(wagonData[isOuterDoor3Enabled.groupIndex]?.[isOuterDoor3Enabled.infoIndex]) === DOOR_SYSTEM.STATUS.OUTER_DOOR_ENABLED) {
          setColor(Color.Blue); return true;
        }
        // Gray state
        if (Number(wagonData[isOuterDoor3ClosedAndLocked.groupIndex]?.[isOuterDoor3ClosedAndLocked.infoIndex]) === DOOR_SYSTEM.STATUS.OUTER_DOOR_CLOSED_AND_LOCKED) {
          setColor(Color.Gray); return true;
        }

        return false;
      }),
      createColorRule(TCDD_UNIT.OUTER_DOOR_4, (wagonIndex: number, data: any[], setColor: (color: Color) => void) => {
        const wagonData = data?.[TcddSubSystem.DOOR_SYSTEM]?.[wagonIndex];
        if (!wagonData) return false;

        const isOuterDoor4CommunicationError: ValueIndex = getIndex(DoorSystemKeys.isOuterDoor4CommunicationError); // === 1 will be pink
        const isOuterDoor4OutOfService: ValueIndex = getIndex(DoorSystemKeys.isOuterDoor4OutOfService); // === 1 will be yellow
        const isOuterDoor4MajorError: ValueIndex = getIndex(DoorSystemKeys.isOuterDoor4MajorError); // === 1 will be red
        const isOuterDoor4MinorError: ValueIndex = getIndex(DoorSystemKeys.isOuterDoor4MinorError); // === 1 will be orange
        const isOuterDoor4FullyOpen: ValueIndex = getIndex(DoorSystemKeys.isOuterDoor4FullyOpen); // === 1 will be light green
        const isOuterDoor4Enabled: ValueIndex = getIndex(DoorSystemKeys.isOuterDoor4Enabled); // === 1 will be blue
        const isOuterDoor4ClosedAndLocked: ValueIndex = getIndex(DoorSystemKeys.isOuterDoor4ClosedAndLocked); // === 1 will be gray

        // Pink state
        if (Number(wagonData[isOuterDoor4CommunicationError.groupIndex]?.[isOuterDoor4CommunicationError.infoIndex]) === DOOR_SYSTEM.STATUS.OUTER_DOOR_COMMUNICATION_ERROR) {
          setColor(Color.Pink); return true;
        }
        // Yellow state
        if (Number(wagonData[isOuterDoor4OutOfService.groupIndex]?.[isOuterDoor4OutOfService.infoIndex]) === DOOR_SYSTEM.STATUS.OUTER_DOOR_OUT_OF_SERVICE) {
          setColor(Color.Yellow ); return true;
        }
        // Red State
        if (Number(wagonData[isOuterDoor4MajorError.groupIndex]?.[isOuterDoor4MajorError.infoIndex]) === DOOR_SYSTEM.STATUS.OUTER_DOOR_MAJOR_ERROR) {
          setColor(Color.Red); return true;
        }
        // Orange state
        if (Number(wagonData[isOuterDoor4MinorError.groupIndex]?.[isOuterDoor4MinorError.infoIndex]) === DOOR_SYSTEM.STATUS.OUTER_DOOR_MINOR_ERROR) {
          setColor(Color.Orange); return true;
        }
        // Light green state
        if (Number(wagonData[isOuterDoor4FullyOpen.groupIndex]?.[isOuterDoor4FullyOpen.infoIndex]) === DOOR_SYSTEM.STATUS.OUTER_DOOR_FULLY_OPEN) {
          setColor(Color.Green); return true;
        }
        // Blue state
        if (Number(wagonData[isOuterDoor4Enabled.groupIndex]?.[isOuterDoor4Enabled.infoIndex]) === DOOR_SYSTEM.STATUS.OUTER_DOOR_ENABLED) {
          setColor(Color.Blue); return true;
        }
        // Gray state
        if (Number(wagonData[isOuterDoor4ClosedAndLocked.groupIndex]?.[isOuterDoor4ClosedAndLocked.infoIndex]) === DOOR_SYSTEM.STATUS.OUTER_DOOR_CLOSED_AND_LOCKED) {
          setColor(Color.Gray); return true;
        }

        return false;
      }),
      createColorRule(TCDD_UNIT.INNER_DOOR_1, (wagonIndex: number, data: any[], setColor: (color: Color) => void) => {
        const wagonData = data?.[TcddSubSystem.DOOR_SYSTEM]?.[wagonIndex];
        if (!wagonData) return false;

        const isInnerDoor1CommunicationError: ValueIndex = getIndex(DoorSystemKeys.isInnerDoor1CommunicationError); // === 1 will be pink
        const isInnerDoor1MajorError: ValueIndex = getIndex(DoorSystemKeys.isInnerDoor1MajorError); // === 1 will be red
        const isInnerDoor1MinorError: ValueIndex = getIndex(DoorSystemKeys.isInnerDoor1MinorError); // === 1 will be orange
        const isInnerDoor1LockedCloseAndLockedOpen: ValueIndex = getIndex(DoorSystemKeys.isInnerDoor1LockedCloseAndLockedOpen); // === 1 will be yellow

        // Pink state
        if (Number(wagonData[isInnerDoor1CommunicationError.groupIndex]?.[isInnerDoor1CommunicationError.infoIndex]) === DOOR_SYSTEM.STATUS.INNER_DOOR_COMMUNICATION_ERROR) {
          setColor(Color.Pink); return true;
        }
        // Red State
        if (Number(wagonData[isInnerDoor1MajorError.groupIndex]?.[isInnerDoor1MajorError.infoIndex]) === DOOR_SYSTEM.STATUS.INNER_DOOR_MAJOR_ERROR) {
          setColor(Color.Red); return true;
        }
        // Orange state
        if (Number(wagonData[isInnerDoor1MinorError.groupIndex]?.[isInnerDoor1MinorError.infoIndex]) === DOOR_SYSTEM.STATUS.INNER_DOOR_MINOR_ERROR) {
          setColor(Color.Orange); return true;
        }
        // Yellow state
        if (Number(wagonData[isInnerDoor1LockedCloseAndLockedOpen.groupIndex]?.[isInnerDoor1LockedCloseAndLockedOpen.infoIndex]) === DOOR_SYSTEM.STATUS.INNER_DOOR_LOCKED) {
          setColor(Color.Yellow); return true;
        }

        return false;
      }),
      createColorRule(TCDD_UNIT.INNER_DOOR_2, (wagonIndex: number, data: any[], setColor: (color: Color) => void) => {
        const wagonData = data?.[TcddSubSystem.DOOR_SYSTEM]?.[wagonIndex];
        if (!wagonData) return false;

        const isInnerDoor2CommunicationError: ValueIndex = getIndex(DoorSystemKeys.isInnerDoor2CommunicationError); // === 1 will be pink
        const isInnerDoor2MajorError: ValueIndex = getIndex(DoorSystemKeys.isInnerDoor2MajorError); // === 1 will be red
        const isInnerDoor2MinorError: ValueIndex = getIndex(DoorSystemKeys.isInnerDoor2MinorError); // === 1 will be orange
        const isInnerDoor2LockedCloseAndLockedOpen: ValueIndex = getIndex(DoorSystemKeys.isInnerDoor2LockedCloseAndLockedOpen); // === 1 will be yellow

        // Pink state
        if (Number(wagonData[isInnerDoor2CommunicationError.groupIndex]?.[isInnerDoor2CommunicationError.infoIndex]) === DOOR_SYSTEM.STATUS.INNER_DOOR_COMMUNICATION_ERROR) {
          setColor(Color.Pink); return true;
        }
        // Red State
        if (Number(wagonData[isInnerDoor2MajorError.groupIndex]?.[isInnerDoor2MajorError.infoIndex]) === DOOR_SYSTEM.STATUS.INNER_DOOR_MAJOR_ERROR) {
          setColor(Color.Red); return true;
        }
        // Orange state
        if (Number(wagonData[isInnerDoor2MinorError.groupIndex]?.[isInnerDoor2MinorError.infoIndex]) === DOOR_SYSTEM.STATUS.INNER_DOOR_MINOR_ERROR) {
          setColor(Color.Orange); return true;
        }
        // Yellow state
        if (Number(wagonData[isInnerDoor2LockedCloseAndLockedOpen.groupIndex]?.[isInnerDoor2LockedCloseAndLockedOpen.infoIndex]) === DOOR_SYSTEM.STATUS.INNER_DOOR_LOCKED) {
          setColor(Color.Yellow); return true;
        }

        return false;
      }),
      createColorRule(TCDD_UNIT.END_DOOR_1, (wagonIndex: number, data: any[], setColor: (color: Color) => void) => {
        const wagonData = data?.[TcddSubSystem.DOOR_SYSTEM]?.[wagonIndex];
        if (!wagonData) return false;

        const isEndDoor1CommunicationError: ValueIndex = getIndex(DoorSystemKeys.isEndDoor1CommunicationError); // === 1 will be pink
        const isEndDoor1MajorError: ValueIndex = getIndex(DoorSystemKeys.isEndDoor1MajorError); // === 1 will be red
        const isEndDoor1MinorError: ValueIndex = getIndex(DoorSystemKeys.isEndDoor1MinorError); // === 1 will be orange
        const isEndDoor1LockedCloseAndLockedOpen: ValueIndex = getIndex(DoorSystemKeys.isEndDoor1LockedCloseAndLockedOpen); // === 1 will be yellow

        // Pink state
        if (Number(wagonData[isEndDoor1CommunicationError.groupIndex]?.[isEndDoor1CommunicationError.infoIndex]) === DOOR_SYSTEM.STATUS.END_DOOR_COMMUNICATION_ERROR) {
          setColor(Color.Pink); return true;
        }
        // Red State
        if (Number(wagonData[isEndDoor1MajorError.groupIndex]?.[isEndDoor1MajorError.infoIndex]) === DOOR_SYSTEM.STATUS.END_DOOR_MAJOR_ERROR) {
          setColor(Color.Red); return true;
        }
        // Orange state
        if (Number(wagonData[isEndDoor1MinorError.groupIndex]?.[isEndDoor1MinorError.infoIndex]) === DOOR_SYSTEM.STATUS.END_DOOR_MINOR_ERROR) {
          setColor(Color.Orange); return true;
        }
        // Yellow state
        if (Number(wagonData[isEndDoor1LockedCloseAndLockedOpen.groupIndex]?.[isEndDoor1LockedCloseAndLockedOpen.infoIndex]) === DOOR_SYSTEM.STATUS.END_DOOR_LOCKED) {
          setColor(Color.Yellow); return true;
        }

        return false;
      }),
      createColorRule(TCDD_UNIT.END_DOOR_2, (wagonIndex: number, data: any[], setColor: (color: Color) => void) => {
        const wagonData = data?.[TcddSubSystem.DOOR_SYSTEM]?.[wagonIndex];
        if (!wagonData) return false;

        const isEndDoor2CommunicationError: ValueIndex = getIndex(DoorSystemKeys.isEndDoor2CommunicationError); // === 1 will be pink
        const isEndDoor2MajorError: ValueIndex = getIndex(DoorSystemKeys.isEndDoor2MajorError); // === 1 will be red
        const isEndDoor2MinorError: ValueIndex = getIndex(DoorSystemKeys.isEndDoor2MinorError); // === 1 will be orange
        const isEndDoor2LockedCloseAndLockedOpen: ValueIndex = getIndex(DoorSystemKeys.isEndDoor2LockedCloseAndLockedOpen); // === 1 will be yellow

        // Pink state
        if (Number(wagonData[isEndDoor2CommunicationError.groupIndex]?.[isEndDoor2CommunicationError.infoIndex]) === DOOR_SYSTEM.STATUS.END_DOOR_COMMUNICATION_ERROR) {
          setColor(Color.Pink); return true;
        }
        // Red State
        if (Number(wagonData[isEndDoor2MajorError.groupIndex]?.[isEndDoor2MajorError.infoIndex]) === DOOR_SYSTEM.STATUS.END_DOOR_MAJOR_ERROR) {
          setColor(Color.Red); return true;
        }
        // Orange state
        if (Number(wagonData[isEndDoor2MinorError.groupIndex]?.[isEndDoor2MinorError.infoIndex]) === DOOR_SYSTEM.STATUS.END_DOOR_MINOR_ERROR) {
          setColor(Color.Orange); return true;
        }
        // Yellow state
        if (Number(wagonData[isEndDoor2LockedCloseAndLockedOpen.groupIndex]?.[isEndDoor2LockedCloseAndLockedOpen.infoIndex]) === DOOR_SYSTEM.STATUS.END_DOOR_LOCKED) {
          setColor(Color.Yellow); return true;
        }

        return false;
      }),
      createColorRule(TCDD_UNIT.BISTRO_DOOR, (wagonIndex: number, data: any[], setColor: (color: Color) => void) => {
        const wagonData = data?.[TcddSubSystem.DOOR_SYSTEM]?.[wagonIndex];
        if (!wagonData) return false;

        const isBistroDoorCommunicationError: ValueIndex = getIndex(DoorSystemKeys.isBistroDoorCommunicationError); // === 1 will be pink
        const isBistroDoorMajorError: ValueIndex = getIndex(DoorSystemKeys.isBistroDoorMajorError); // === 1 will be red
        const isBistroDoorMinorError: ValueIndex = getIndex(DoorSystemKeys.isBistroDoorMinorError); // === 1 will be orange
        const isBistroDoorLockedCloseAndLockedOpen: ValueIndex = getIndex(DoorSystemKeys.isBistroDoorLockedCloseAndLockedOpen); // === 1 will be yellow

        // Pink state
        if (Number(wagonData[isBistroDoorCommunicationError.groupIndex]?.[isBistroDoorCommunicationError.infoIndex]) === DOOR_SYSTEM.STATUS.BISTRO_COMMUNICATION_ERROR) {
          setColor(Color.Pink); return true;
        }
        // Red State
        if (Number(wagonData[isBistroDoorMajorError.groupIndex]?.[isBistroDoorMajorError.infoIndex]) === DOOR_SYSTEM.STATUS.BISTRO_DOOR_MAJOR_ERROR) {
          setColor(Color.Red); return true;
        }
        // Orange state
        if (Number(wagonData[isBistroDoorMinorError.groupIndex]?.[isBistroDoorMinorError.infoIndex]) === DOOR_SYSTEM.STATUS.BISTRO_DOOR_MINOR_ERROR) {
          setColor(Color.Orange); return true;
        }
        // Yellow state
        if (Number(wagonData[isBistroDoorLockedCloseAndLockedOpen.groupIndex]?.[isBistroDoorLockedCloseAndLockedOpen.infoIndex]) === DOOR_SYSTEM.STATUS.BISTRO_DOOR_LOCKED) {
          setColor(Color.Yellow); return true;
        }

        return false;
      }),
      createColorRule(TCDD_UNIT.PRM_DOOR_1, (wagonIndex: number, data: any[], setColor: (color: Color) => void) => {
        const wagonData = data?.[TcddSubSystem.DOOR_SYSTEM]?.[wagonIndex];
        if (!wagonData) return false;

        const isOuterDoor1CommunicationError: ValueIndex = getIndex(DoorSystemKeys.isOuterDoor1CommunicationError); // === 1 will be pink
        const isOuterDoor1ClosedAndLocked: ValueIndex = getIndex(DoorSystemKeys.isOuterDoor1ClosedAndLocked); // === 1 will be gray
        const isOuterDoor1FullyOpen: ValueIndex = getIndex(DoorSystemKeys.isOuterDoor1FullyOpen); // === 1 will be green
        const isPRMDoor1Active: ValueIndex = getIndex(DoorSystemKeys.isPRMDoor1Active); // === 1 will be green

        if ( // Pink state
          Number(wagonData[isOuterDoor1CommunicationError.groupIndex]?.[isOuterDoor1CommunicationError.infoIndex]) === DOOR_SYSTEM.STATUS.OUTER_DOOR_COMMUNICATION_ERROR) {
          setColor(Color.Pink); return true;
        }
        if ( // Green State
          Number(wagonData[isOuterDoor1FullyOpen.groupIndex]?.[isOuterDoor1FullyOpen.infoIndex]) === DOOR_SYSTEM.STATUS.OUTER_DOOR_FULLY_OPEN &&
          Number(wagonData[isPRMDoor1Active.groupIndex]?.[isPRMDoor1Active.infoIndex]) === DOOR_SYSTEM.STATUS.PRM_DOOR_ACTIVE) {
          setColor(Color.Green); return true;
        }
        if ( // Gray state
          Number(wagonData[isOuterDoor1ClosedAndLocked.groupIndex]?.[isOuterDoor1ClosedAndLocked.infoIndex]) === DOOR_SYSTEM.STATUS.OUTER_DOOR_CLOSED_AND_LOCKED) {
          setColor(Color.Gray); return true;
        }

        return false;
      }),
      createColorRule(TCDD_UNIT.PRM_DOOR_2, (wagonIndex: number, data: any[], setColor: (color: Color) => void) => {
        const wagonData = data?.[TcddSubSystem.DOOR_SYSTEM]?.[wagonIndex];
        if (!wagonData) return false;

        const isOuterDoor2CommunicationError: ValueIndex = getIndex(DoorSystemKeys.isOuterDoor2CommunicationError); // === 1 will be pink
        const isOuterDoor2ClosedAndLocked: ValueIndex = getIndex(DoorSystemKeys.isOuterDoor2ClosedAndLocked); // === 1 will be gray
        const isOuterDoor2FullyOpen: ValueIndex = getIndex(DoorSystemKeys.isOuterDoor2FullyOpen); // === 1 will be green
        const isPRMDoor2Active: ValueIndex = getIndex(DoorSystemKeys.isPRMDoor2Active); // === 1 will be green

        if ( // Pink state
          Number(wagonData[isOuterDoor2CommunicationError.groupIndex]?.[isOuterDoor2CommunicationError.infoIndex]) === DOOR_SYSTEM.STATUS.OUTER_DOOR_COMMUNICATION_ERROR) {
          setColor(Color.Pink); return true;
        }
        if ( // Green State
          Number(wagonData[isOuterDoor2FullyOpen.groupIndex]?.[isOuterDoor2FullyOpen.infoIndex]) === DOOR_SYSTEM.STATUS.OUTER_DOOR_FULLY_OPEN &&
          Number(wagonData[isPRMDoor2Active.groupIndex]?.[isPRMDoor2Active.infoIndex]) === DOOR_SYSTEM.STATUS.PRM_DOOR_ACTIVE) {
          setColor(Color.Green); return true;
        }
        if ( // Gray state
          Number(wagonData[isOuterDoor2ClosedAndLocked.groupIndex]?.[isOuterDoor2ClosedAndLocked.infoIndex]) === DOOR_SYSTEM.STATUS.OUTER_DOOR_CLOSED_AND_LOCKED) {
          setColor(Color.Gray); return true;
        }

        return false;
      })
    ];
  }
}
